/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReplicaSet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M10 2v2H8V2zm4 0v2h-2V2zm4 0v2h-2V2zm4 0v2h-2V2zm0 4v2h-2V6zm0 4v2h-2v-2zm-4 0v12H2V10zM4 12v8h12v-8zm2-4V6H4v2zm4 0V6H8v2zm4 0V6h-2v2zm4 0V6h-2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgReplicaSet as ReplicaSet };
